import { officeProductOperationPriceConstants as C } from '../actions/constants'

const initialState = {
    byProduct: {},
    resolvedByProduct: {},
    calculations: {},
    loading: false,
    resolving: false,
    saving: false,
    calculating: false,
    lastTouchedId: null,
    error: null,
}

const mergePrice = (list, price) => {
    if (!price?._id) return list || []

    const next = [...(list || [])]
    const index = next.findIndex((item) => String(item._id) === String(price._id))

    if (index >= 0) {
        next[index] = price
    } else {
        next.unshift(price)
    }

    return next
}

const officeProductOperationPriceReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_PRODUCT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.RESOLVE_PRODUCT_REQUEST:
            return {
                ...state,
                resolving: true,
                error: null,
            }

        case C.UPSERT_REQUEST:
        case C.REMOVE_REQUEST:
            return {
                ...state,
                saving: true,
                lastTouchedId: action.meta?.operationType || action.meta?.operationPriceId || null,
                error: null,
            }

        case C.CALCULATE_REQUEST:
            return {
                ...state,
                calculating: true,
                lastTouchedId: action.meta?.operationPriceId || null,
                error: null,
            }

        case C.LIST_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                byProduct: {
                    ...state.byProduct,
                    [action.payload.productId]: action.payload.prices || [],
                },
            }

        case C.RESOLVE_PRODUCT_SUCCESS:
            return {
                ...state,
                resolving: false,
                resolvedByProduct: {
                    ...state.resolvedByProduct,
                    [action.payload.productId]: action.payload.operations || [],
                },
            }

        case C.UPSERT_SUCCESS: {
            const productId = action.payload?.productId?._id || action.payload?.productId
            const current = state.byProduct[productId] || []
            const next = mergePrice(current, action.payload)

            return {
                ...state,
                saving: false,
                lastTouchedId: null,
                byProduct: {
                    ...state.byProduct,
                    [productId]: next,
                },
            }
        }

        case C.REMOVE_SUCCESS:
            return {
                ...state,
                saving: false,
                lastTouchedId: null,
            }

        case C.CALCULATE_SUCCESS:
            return {
                ...state,
                calculating: false,
                lastTouchedId: null,
                calculations: {
                    ...state.calculations,
                    [action.payload.operationPriceId]: action.payload.calculation,
                },
            }

        case C.LIST_PRODUCT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }

        case C.RESOLVE_PRODUCT_FAILURE:
            return {
                ...state,
                resolving: false,
                error: action.payload,
            }

        case C.UPSERT_FAILURE:
        case C.REMOVE_FAILURE:
            return {
                ...state,
                saving: false,
                lastTouchedId: null,
                error: action.payload,
            }

        case C.CALCULATE_FAILURE:
            return {
                ...state,
                calculating: false,
                lastTouchedId: null,
                error: action.payload,
            }

        default:
            return state
    }
}

export default officeProductOperationPriceReducer